import PosGreeting from './PosGreeting';

export default PosGreeting;
